import { useState } from "react";
import { Grid, Typography, Avatar } from "@mui/material";
import * as React from 'react';
import Button from '@mui/material/Button';
import data from '../data/datasParalela.json';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Financiamento from '../images/financiamento_saude.jpg';
import Responsabilidade from '../images/responsabilidade_federativa.jpg'


const Paralela = () => {
    const [searchValue] = useState('');
    const [selectedDay, setSelectedDay] = useState('1º');
    const [selectedLocation, setSelectedLocation] = useState('');

    const handleDayButtonClick = (day) => {
        setSelectedDay(day);
    };

    const uniqueLocations = Array.from(new Set(data.flatMap((dia) => dia.programacao.map((evento) => evento.local))));

    const allLocations = ['Todos', ...uniqueLocations];

    const handleLocalButtonClick = (local) => {
        setSelectedLocation(local === 'Todos' ? '' : local);
    };

    const filteredData = data.filter((dia) =>
        dia.programacao.some(
            (evento) =>
                evento.local.toLowerCase().includes(searchValue.toLowerCase()) ||
                evento.nome.toLowerCase().includes(searchValue.toLowerCase())
        )
    );

    return (

        <div>
            <Grid container spacing={5} display="flex" alignItems="center" justifyContent="center" sx={{ marginBottom: '5%' }}>

                <Grid item xl={8} lg={9} xs={12} display="flex" alignItems="center" justifyContent="start" flexDirection="row">
                    <Typography sx={{ fontSize: { xl: '2.8rem', lg: '2.5rem', xs: '1.8rem' }, color: '#87C705', fontWeight: 'bold', marginRight: '1%' }}>Programação</Typography>
                    <Typography sx={{ fontSize: { xl: '2.8rem', lg: '2.5rem', xs: '1.8rem' }, color: '#84AF00', fontWeight: 'bold' }}>Paralela</Typography>
                </Grid>

                <Grid item xl={8} lg={8} display="flex" alignItems="center" justifyContent="space-evenly" sx={{ marginBottom: '20px' }}>
                    {filteredData.map((dia) => (
                        <Grid item xl={2} lg={2} xs={12} sm={6} md={4} key={dia}>
                            <Button
                                key={dia.dia}
                                sx={{
                                    width: '14vw',
                                    height: '12vh',
                                    backgroundColor: selectedDay === dia.dia ? '#87C705' : '#f1f1f1',
                                    color: selectedDay === dia.dia ? '#fff' : '#b5b5b5',
                                    fontSize: { xl: '30px', lg: '25px' },
                                    fontWeight: 'bold',
                                    border: '1px solid #f1f1f1',
                                    borderRadius: '10px',
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)'
                                }}
                                onClick={() => handleDayButtonClick(dia.dia)}
                            >
                                {`${dia.dia} dia`}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
                <Grid item xl={8} lg={8} xs={12} display="flex" alignItems="center" justifyContent="space-evenly" sx={{ marginBottom: '20px' }}>
                    <Typography sx={{ fontWeight: 'bold', color: '#b5b5b5' }}> <FilterAltOutlinedIcon sx={{ color: '#84AF00' }} /> Filtrar por Local: </Typography>
                    <Grid container spacing={2} justifyContent="center">
                        {allLocations.map((local) => (
                            <Grid item xl={2} lg={2} xs={12} sm={6} md={4} key={local}>
                                <Button
                                    sx={{
                                        width: { xl: '8.5vw', lg: '8.5vw', xs: '70%' },
                                        height: '6.5vh',
                                        backgroundColor: selectedLocation === local ? '#87C705' : '#f1f1f1',
                                        color: selectedLocation === local ? '#fff' : '#b5b5b5',
                                        fontSize: { xl: '14px', lg: '14px', xs: '10px' },
                                        fontWeight: 'bold',
                                        border: '1px solid #f1f1f1',
                                        borderRadius: '10px',
                                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)'
                                    }}
                                    onClick={() => handleLocalButtonClick(local)}
                                >
                                    {local}
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Grid item xl={8} lg={10} xs={12} alignItems="center" justifyContent="center" sx={{ display: 'flex', flexDirection: "column", height: 'auto', gap: { xl: 15, lg: 15, xs: 5 }, border: '4px solid #f1f1f1', borderRadius: '25px', padding: 5 }}>
                    {filteredData.map((dia) => (
                        <React.Fragment key={dia.dia}>
                            {selectedDay === dia.dia && dia.programacao
                                .filter((evento) =>
                                    evento.local.toLowerCase().includes(selectedLocation.toLowerCase()) &&
                                    (evento.local.toLowerCase().includes(searchValue.toLowerCase()) ||
                                        evento.nome.toLowerCase().includes(searchValue.toLowerCase()))
                                )
                                .map((evento, index) => (
                                    <Grid key={index} display="flex" alignItems="center" justifyContent="center" sx={{ backgroundColor: '#f1f1f1', gap: { xl: 5, lg: 5, xs: 3 }, width: { xl: '95%', lg: '95%', xs: '100%' }, height: { xl: '13vh', lg: '13vh', xs: '15vh' }, overflow: { xs: 'visible' }, borderRadius: '5px' }}>
                                        <Typography sx={{ color: '#84AF00', fontWeight: 'bold', fontSize: { xl: '25px', xs: '20px' }, marginLeft: '1%' }}>{evento.hora}</Typography>
                                        {evento.nome === "Financiamento do SUS: mudanças e tendências" ? (
                                            <Avatar src={Financiamento} sx={{ width: { xl: 180, lg: 130, xs: 100 }, height: { xl: 180, lg: 130, xs: 100 }, backgroundColor: 'rgba(255,255,255, 0.4)' }} />
                                        ) : evento.nome === "Retomada das responsabilidades interfederativas no SUS" ? (
                                            <Avatar src={Responsabilidade} sx={{ width: { xl: 180, lg: 130, xs: 100 }, height: { xl: 180, lg: 130, xs: 100 }, backgroundColor: 'rgba(255,255,255, 0.4)' }} />
                                        ) : (
                                            <Avatar src={evento.imagem} sx={{ width: { xl: 180, lg: 130, xs: 100 }, height: { xl: 180, lg: 130, xs: 100 }, backgroundColor: 'rgba(255,255,255, 0.4)' }} />
                                        )}
                                        <Typography sx={{ fontSize: { xl: '18px', lg: '18px', xs: '10px' }, color: '#969696', width: '40%', textAlign: 'center', fontWeight: 'bold' }}>
                                            {evento.nome}
                                        </Typography>
                                        {/* <Typography sx={{ color: '#84AF00', width: '4%', fontWeight: 'bold', fontSize: { xl: '20px', lg: '20px', xs: '14px' } }}>
                                            {`#${evento.hashtag} ${evento.hashtag2 ? `#${evento.hashtag2}` : ''} ${evento.hashtag3 ? `#${evento.hashtag3}` : ''}`}
                                        </Typography> */}
                                        <Typography sx={{ fontSize: { xl: '20px', lg: '20px', xs: '15px' }, color: '#84AF00', width: { xl: '18%', lg: '18%', xs: '25%' }, textAlign: 'center', fontWeight: 'bold', ml: { xs: '12%' } }}>
                                            {evento.local}
                                        </Typography>
                                    </Grid>
                                ))}
                        </React.Fragment>
                    ))}
                </Grid>
            </Grid>
        </div >
    );
};

export default Paralela;
